import { type ModalHeaderConfig } from "../types";
import { HStack } from "../../../primitives/stack";
import { Button } from "../../button";
import { useStyles } from "./headerStyles";
import { Title } from "../../title";

export const DefaultModalHeader = ({
  title,
  titleVariant = "h3",
  leftButton,
  leftButtonVariant = "ghost",
  rightButtonVariant = "primary",
  rightButton,
  onLeftPress,
  onRightPress,
}: ModalHeaderConfig) => {
  const styles = useStyles();

  return (
    <HStack
      alignItems="center"
      justifyContent="space-between"
      style={styles.containerStyles}
    >
      {leftButton && (
        <Button variant={leftButtonVariant} onClick={onLeftPress}>
          {leftButton}
        </Button>
      )}

      <Title variant={titleVariant}>{title}</Title>

      {rightButton && (
        <Button variant={rightButtonVariant} onClick={onRightPress}>
          {rightButton}
        </Button>
      )}
    </HStack>
  );
};
